const PREFIX = "COMMON_EVENT";

export const commonActionTypes = {
  discard: `${PREFIX}_DISCARD`,
};
